import type {ReactNode} from "react";

interface MainFrameProps {
    children: ReactNode;
}

export function MainFrame({children}: MainFrameProps) {
    return (
        <main className="grow p-6 w-full min-w-0">
            <div className="flex flex-col w-full h-full">{children}</div>
        </main>
    );
}

interface MainToolbarProps {
    title: ReactNode;
    children?: ReactNode;
}

export function MainToolbar({children, title}: MainToolbarProps) {
    return (
        <h2 className="flex mt-0 items-center">
            <div className={`my-2 ${children ? "HeaderTextShared" : "HeaderText"}`}>{title}:</div>
            {children}
        </h2>
    );
}
